import { useEffect, useState } from "react";
import "./PopupForm.css";

export default function PopupForm() {
  const [show, setShow] = useState(false);

  // FORM STATES
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [purity, setPurity] = useState("");
  const [gram, setGram] = useState("");

  // OPEN POPUP
  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 500);
  }, []);

  if (!show) return null;

  // SUBMIT FUNCTION
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !phone) {
      alert("Please fill required fields");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone", phone);
    formData.append("purity", purity);
    formData.append("gram", gram);

    try {
      const res = await fetch("https://cashforgold.org.in/send.php", {
        method: "POST",
        body: formData,
      });

      // 👇 SAFE RESPONSE HANDLING
      const text = await res.text();
      console.log("SERVER RESPONSE:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        alert("Invalid server response ❌");
        return;
      }

      if (data.status === "success") {
        alert("Message sent successfully ✅");

        // CLEAR FORM
        setName("");
        setPhone("");
        setPurity("");
        setGram("");

        // CLOSE POPUP
        setShow(false);
      } else {
        alert("Error sending message ❌");
      }

    } catch (err) {
      console.error("FETCH ERROR:", err);
      alert("Server connection failed ❌");
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">

        {/* CLOSE BUTTON */}
        <span className="close-btn" onClick={() => setShow(false)}>
          ×
        </span>

        <h2>Get in Touch with Trusted Gold Buying.</h2>

        <form onSubmit={handleSubmit}>

          {/* NAME */}
          <div className="input-group">
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <label>Name</label>
          </div>

          {/* PHONE */}
          <input
            type="text"
            placeholder="Phone"
            required
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          {/* PURITY */}
          <select
            value={purity}
            onChange={(e) => setPurity(e.target.value)}
          >
            <option value="">Gold Purity</option>
            <option value="24K">24K</option>
            <option value="22K">22K</option>
            <option value="18K">18K</option>
          </select>

          {/* GRAM */}
          <input
            type="text"
            placeholder="Gram"
            value={gram}
            onChange={(e) => setGram(e.target.value)}
          />

          {/* BUTTON */}
          <button type="submit">SUBMIT</button>

        </form>

      </div>
    </div>
  );
}